var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrantDriveLogoFooter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.239,
    height: 10.25,
    viewBox: "0 0 68.239 10.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_616",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 616",
    transform: "translate(-297.975 -382.438)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_14",
    "data-name": "\\u30D1\\u30B9 14",
    d: "M550,720.99h0Z",
    transform: "translate(-217.905 -332.802)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_615",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 615",
    transform: "translate(297.975 382.438)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_614",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 614",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_17",
    "data-name": "\\u30D1\\u30B9 17",
    d: "M330.511,692.789a7.046,7.046,0,0,1-1.907.287,6.861,6.861,0,0,1-1.927-.355,4.934,4.934,0,0,1-2.139-1.387,4.036,4.036,0,0,1-.977-2.891,6.429,6.429,0,0,1,.561-2.576A5.181,5.181,0,0,1,325.9,683.7a5.111,5.111,0,0,1,3.061-.875,7.651,7.651,0,0,1,1.859.232,5.526,5.526,0,0,1,1.654.7l-.875,1.8a4.372,4.372,0,0,0-1.223-.54,4.925,4.925,0,0,0-1.333-.2,3.353,3.353,0,0,0-2.009.554,3.015,3.015,0,0,0-1.08,1.36,4.482,4.482,0,0,0-.314,1.64,2.3,2.3,0,0,0,.608,1.7,3.1,3.1,0,0,0,1.353.82,4.888,4.888,0,0,0,1.319.212,2.25,2.25,0,0,0,1.121-.191l.15-1.312h-1.736l.232-1.9h3.759l-.533,4.456A3.723,3.723,0,0,1,330.511,692.789Z",
    transform: "translate(-323.561 -682.825)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_18",
    "data-name": "\\u30D1\\u30B9 18",
    d: "M391.532,709.849a3.432,3.432,0,0,1,.759-.868,3.615,3.615,0,0,1,.929-.567,2.248,2.248,0,0,1,.827-.191l-.328,1.913a1.537,1.537,0,0,0-.232-.014,1.907,1.907,0,0,0-1.046.3,2.43,2.43,0,0,0-.765.772,2.286,2.286,0,0,0-.349.964l-.287,2.337h-1.9l.724-5.973h1.722Z",
    transform: "translate(-379.259 -704.396)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_19",
    "data-name": "\\u30D1\\u30B9 19",
    d: "M430.635,708.524l-.724,5.973H428l.082-.738a3.2,3.2,0,0,1-2.31.875,2.078,2.078,0,0,1-1.162-.335,2.594,2.594,0,0,1-.916-1.018,3.272,3.272,0,0,1-.355-1.558,3.5,3.5,0,0,1,.437-1.695,3.559,3.559,0,0,1,1.2-1.305,3.083,3.083,0,0,1,1.722-.5,2.533,2.533,0,0,1,1.23.246,2.121,2.121,0,0,1,.724.67l.2-.615Zm-2.187,2.214a1.175,1.175,0,0,0-.478-.7,1.552,1.552,0,0,0-.916-.26,1.726,1.726,0,0,0-.977.26,1.587,1.587,0,0,0-.574.656,1.864,1.864,0,0,0-.184.793,1.633,1.633,0,0,0,.417,1.175,1.561,1.561,0,0,0,1.893.212,1.961,1.961,0,0,0,.643-.677Z",
    transform: "translate(-408.303 -704.396)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_20",
    "data-name": "\\u30D1\\u30B9 20",
    d: "M483.842,708.812a1.546,1.546,0,0,1,.431,1.292l-.547,4.469h-1.913l.465-3.758a.906.906,0,0,0-.157-.649.761.761,0,0,0-.622-.226,1.388,1.388,0,0,0-1.128.615,3.126,3.126,0,0,0-.581,1.585l-.3,2.433h-1.913l.724-5.973h1.736l.027.888a2.779,2.779,0,0,1,1.025-.861,3.1,3.1,0,0,1,1.407-.315A1.821,1.821,0,0,1,483.842,708.812Z",
    transform: "translate(-454.369 -704.473)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_21",
    "data-name": "\\u30D1\\u30B9 21",
    d: "M532.43,692.8l-.314,2.6h1.449l-.177,1.49h-1.449l-.547,4.51h-1.913l.547-4.51h-.93l.178-1.49h.929l.314-2.6Z",
    transform: "translate(-498.125 -691.299)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_22",
    "data-name": "\\u30D1\\u30B9 22",
    d: "M569.692,683.1h3.553a4.7,4.7,0,0,1,2.529.615,3.607,3.607,0,0,1,1.428,1.613,5.386,5.386,0,0,1,.444,2.214,7.455,7.455,0,0,1-.041.765,5.6,5.6,0,0,1-.916,2.556,5.153,5.153,0,0,1-4.292,2.3h-3.936Zm2.6,8.146a3.234,3.234,0,0,0,2.248-.793,3.445,3.445,0,0,0,1.046-2.282,3.859,3.859,0,0,0,.041-.547,2.6,2.6,0,0,0-.431-1.579,2.337,2.337,0,0,0-1.018-.813,3.049,3.049,0,0,0-1.121-.232h-1.613l-.766,6.246Z",
    transform: "translate(-531.561 -683.057)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_23",
    "data-name": "\\u30D1\\u30B9 23",
    d: "M635.435,709.849a3.432,3.432,0,0,1,.758-.868,3.615,3.615,0,0,1,.929-.567,2.248,2.248,0,0,1,.827-.191l-.328,1.913a1.538,1.538,0,0,0-.232-.014,1.906,1.906,0,0,0-1.046.3,2.428,2.428,0,0,0-.765.772,2.285,2.285,0,0,0-.349.964l-.287,2.337h-1.9l.724-5.973h1.722Z",
    transform: "translate(-586.411 -704.396)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_24",
    "data-name": "\\u30D1\\u30B9 24",
    d: "M669.344,692.5l-.738,5.973h-1.913l.738-5.973Zm-1.483-2.843a1.077,1.077,0,0,1,.786-.3,1.216,1.216,0,0,1,.711.219.76.76,0,0,1,.314.67.991.991,0,0,1-.308.738,1.076,1.076,0,0,1-.786.3,1.215,1.215,0,0,1-.711-.219.76.76,0,0,1-.314-.67A.992.992,0,0,1,667.862,689.658Z",
    transform: "translate(-614.99 -688.373)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_25",
    "data-name": "\\u30D1\\u30B9 25",
    d: "M736.594,712.861l.67,1.476a4.768,4.768,0,0,1-.957.342,4.05,4.05,0,0,1-.957.123,3.468,3.468,0,0,1-2.392-.779,2.933,2.933,0,0,1-.875-2.31,3.446,3.446,0,0,1,.376-1.531,3.144,3.144,0,0,1,1.169-1.271,3.646,3.646,0,0,1,2-.506,3.248,3.248,0,0,1,2.077.669,3.524,3.524,0,0,1,1.066,2.419L734.3,712.6a1.23,1.23,0,0,0,.554.451,1.846,1.846,0,0,0,.7.137A2.32,2.32,0,0,0,736.594,712.861Zm-2.207-2.5a1.708,1.708,0,0,0-.389,1.134v.041l2.72-.711a1.209,1.209,0,0,0-.424-.683,1.163,1.163,0,0,0-.738-.246A1.439,1.439,0,0,0,734.387,710.359Z",
    transform: "translate(-670.529 -704.551)",
    fill: "#3e3e3e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_26",
    "data-name": "\\u30D1\\u30B9 26",
    d: "M688.107,714.75l-1.893-3.114,1.448-.88.734,1.208,3.39-3.618,1.236,1.159Z",
    transform: "translate(-631.57 -704.5)",
    fill: "#3e3e3e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrantDriveLogoFooter);
export default __webpack_public_path__ + "static/media/GrantDrive_logo_footer.041ef74761c525cbb3d0d5def6a4df45.svg";
export { ForwardRef as ReactComponent };